import { HIGHLIGHT_COLORS_NAMES } from 'chameleon/packages/blue-book-player/Annotation/constants';

const SAVE_INTERVAL_DURATION = 60; //seconds

const defaultPlayerConfig = {
  configuration: {
    //onsubmit_redirect_url: submitUrl,
    responsive_regions: false,
    renderSaveButton: true,
    lazyload: true,
    events: true,
  },
  region_overrides: {
    slider_element: {
      scrollable_option: true,
    },
    'items.progress_element': false,
    'right.expand_menu': false,
    'right.reviewscreen_button': false,
    'top-left.masking_button': false,
    'top-left.title_element': false,
    'right.accessibility_button': {
      zoom_option: false,
    },
  },
  regions: {
    'top-left': [
      {
        type: 'title_element',
        position: 'left',
      },
    ],
    'top-right': [
      {
        type: 'previous_button',
        position: 'right',
      },
      {
        type: 'itemcount_element',
        position: 'right',
      },
      {
        type: 'next_button',
        position: 'right',
        hide_label_option: true,
        enable_basic_next_option: false,
      },
    ],
    right: [
      {
        type: 'calculator_button',
      },
      {
        type: 'accessibility_button',
      },
    ],
    items: [
      {
        type: 'previous_button',
        position: 'left',
      },
      {
        type: 'next_button',
        position: 'right',
        hide_label_option: true,
        enable_basic_next_option: false,
      },
    ],
  },
  questions_api_init_options: {
    showCorrectAnswers: false,
  },
  navigation: {
    scroll_to_test: false,
    scroll_to_top: false,
    show_intro: false,
    show_outro: false,
    auto_save: {
      save_interval_duration: SAVE_INTERVAL_DURATION,
      ui: true,
    },
  },
  label_bundle: {
    fontSizeInstructions: 'Adjust the font size in the exam player.',
    paletteInstructions: 'Change the color scheme of the exam player.',
  },
};
export default defaultPlayerConfig;

/**
hide the preview player bottom navigation arrow since
functionality is not the same as the top right navigation
see https://academicmerit.atlassian.net/browse/FY-7321
**/
export const questionBankPreviewConfig = {
  configuration: {
    //onsubmit_redirect_url: submitUrl,
    responsive_regions: false,
    renderSaveButton: true,
    lazyload: true,
  },
  region_overrides: {
    slider_element: {
      scrollable_option: true,
    },
    'items.progress_element': false,
    'right.expand_menu': false,
    'right.reviewscreen_button': false,
    'top-left.masking_button': false,
    'top-left.title_element': false,
    // 'bottom-right.previous_button': false,
    'right.accessibility_button': {
      zoom_option: false,
    },
  },
  regions: {
    'top-left': [
      {
        type: 'title_element',
        position: 'left',
      },
    ],
    'top-right': [
      {
        // just to keep the top-right region so we can mount our custom component
        type: 'custom_button',
        options: {
          name: 'my_custom_navigation',
        },
      },
    ],
    right: [
      {
        type: 'calculator_button',
      },
      {
        type: 'accessibility_button',
      },
    ],
  },
  navigation: {
    scroll_to_test: false,
    scroll_to_top: false,
    show_intro: false,
    show_outro: false,
    auto_save: {
      save_interval_duration: SAVE_INTERVAL_DURATION,
      ui: true,
    },
  },
  events: true,
};

/**
 * Annotation module
 * */
export const annotationModule = {
  annotations_api_init_options: {
    modules: {
      texthighlight: {
        highlight_colors: [
          HIGHLIGHT_COLORS_NAMES.YELLOW,
          HIGHLIGHT_COLORS_NAMES.BLUE,
          HIGHLIGHT_COLORS_NAMES.RED,
        ],
      },
    },
  },
};

export const blueBookPlayerConfig = {
  configuration: {
    responsive_regions: false,
    renderSaveButton: false,
    lazyload: true,
    events: true,
  },
  regions: 'items-only',
  questions_api_init_options: {
    showCorrectAnswers: false,
    render_optimization: {
      defer_render: true,
    },
    attribute_overrides: {
      spellcheck: false,
    },
  },
  navigation: {
    scroll_to_test: false,
    scroll_to_top: false,
    show_intro: false,
    show_outro: false,
    auto_save: {
      save_interval_duration: SAVE_INTERVAL_DURATION,
      ui: true,
    },
  },
};
